.body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 70vh;
  overflow-y: auto;
  padding: 16px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.error {
  color: var(--color-destructive, #ef4444);
}

/* Task preview table — mirrors legacy TaskSetModal preview. */
.previewTitle {
  border-top: 1px solid var(--color-border, #e5e7eb);
  padding-top: 12px;
}

.previewEmpty {
  color: var(--color-muted, #6b7280);
  font-size: 13px;
  padding: 12px 0;
}

.previewTable {
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
}

.previewHead {
  background: var(--color-secondary, #f9fafb);
  color: var(--color-muted, #6b7280);
  display: grid;
  font-size: 12px;
  font-weight: 600;
  grid-template-columns: 2fr 1fr 2fr;
  letter-spacing: 0.4px;
  padding: 8px 12px;
  text-transform: uppercase;
}

.previewRow {
  border-top: 1px solid var(--color-border, #e5e7eb);
  display: grid;
  font-size: 13px;
  grid-template-columns: 2fr 1fr 2fr;
  padding: 10px 12px;
}

.previewRowTitle {
  font-weight: 600;
}

.previewRowDue {
  color: var(--color-muted, #6b7280);
}

.previewRowDue b {
  color: var(--color-foreground);
  font-weight: 600;
}

.assigneeNote {
  color: var(--color-muted, #6b7280);
  font-size: 12px;
}
